// frontend/i18n/index.ts

import es from "./locales/es.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

const translations: Record<string, typeof es> = {
    es,
    en,
    fr,
};

export type TranslationKey = keyof typeof es;

/**
 * Idiomas disponibles
 */
export const availableLanguages = [
    { code: "es", name: "Español" },
    { code: "en", name: "English" },
    { code: "fr", name: "Français" },
];

/**
 * Obtiene las traducciones según el idioma
 */
export function getTranslations(language: string) {
    return translations[language] || translations.es;
}

/**
 * Helper para obtener traducción
 */
export function t(language: string, key: string, params?: Record<string, string | number>): string {
    const lang = translations[language as keyof typeof translations] || translations.es;

    // Soporta keys anidadas: "reservas.titulo"
    const keys = key.split(".");
    let value: any = lang; // Usamos any temporalmente para la navegación

    for (const k of keys) {
        if (value && typeof value === "object" && k in value) {
            value = (value as Record<string, unknown>)[k];
        } else {
            return key; // Devuelve la key si no encuentra traducción
        }
    }

    if (typeof value === "string") {
        if (params) {
            return Object.entries(params).reduce((acc, [key, val]) => {
                return acc.replace(new RegExp(`{${key}}`, "g"), String(val));
            }, value);
        }
        return value;
    }

    return key;
}